import React, { useState } from 'react'
import { navigationItems } from '../constants';
const NavigationDots = () => {

  // const navigationItems = ['home', 'about', 'work', 'skills', 'contact'];
 
  const [currentComp, setCurrentComp] = useState('home');
 
  function updateCurrentComp() {
    setTimeout(()=>{
      setCurrentComp(window.location.hash.slice(1));
    }, 200)
    
  }

  window.onscroll = function(e) {
    const yPos = window.scrollY;

    const totalHeight = window.innerHeight;
    const currIdx = Math.round(yPos / totalHeight);
    setTimeout(()=>{
      setCurrentComp(navigationItems[currIdx]);
    }, 200) 

  }
  
  return (
    <div 
    className='app__navigation'
    >
        {navigationItems.map((item, index)=> (
                
                <a 
                    key={item + index}
                    href={`#${item}`} 
                    className='app__navigation-dot'
                    style={currentComp=== item ? { backgroundColor: 'var(--primary-color)', width: '10px', border:'2px solid var(--accent-color)', borderRadius: '4px'} : {}}
                    onClick={updateCurrentComp}
                    ></a>
              ))}
    </div>
  )
}

export default NavigationDots;